<template>
  <div class="modal-reserve-schedule-container">
    <sweet-modal ref="dateModal" overlay-theme="dark">
      <div class="modal-title">일정 설정</div>
      <div v-if="item" class="content">
        <div class="grid-item">
          <div class="grid-title">운영시간</div>
          <div>
            <!-- 운영 시간 종류 선택 -->
            <div class="flex" style="gap:8px;margin-bottom:20px">
              <div v-for="(opt,idx) in option.types" :key="`opt-${idx}`" @click="item.type = opt.value"
                   class="opt-item unselect" :class="{'opt-item-selected': opt.value === item.type}">
                <div class="flex" style="gap: 8px">
                  <div class="circle"></div>
                  <div class="opt-label weight-700 size-13">{{ opt.label }}</div>
                </div>
                <div class="desc">{{ opt.desc }}</div>
              </div>
            </div>

            <!-- 1회차 -->
            <template v-if="item.type === 0">
              <admin-form-item label="운영시간">
                <admin-date-picker type="date"
                                   :data.sync="item.start_date"></admin-date-picker>

                <time-range-picker
                  start_placeholder="시작시간" end_placeholder="종료시간"
                  :start_time.sync="item.start_time" :end_time.sync="item.end_time" :unit="5"/>
              </admin-form-item>
            </template>

            <!-- 여러 회차 -->
            <template v-else>
              <admin-form-item label="운영시간">
                <admin-date-picker type="date" :data.sync="item.start_date"></admin-date-picker>
              </admin-form-item>
              <div>
                <div class="label-sub">첫 회차 시작시간</div>
                <time-picker style="width:190px" :value.sync="item.start_time"></time-picker>
              </div>
              <admin-form-item label="자동 생성 설정" style="margin-top:20px">
                <div class="flex wrap auto-setting" style="gap:8px 0">
                  <div class="col-6">
                    <div class="sub3">소요시간</div>
                    <div class="grid-auto">
                      <select class="input-border" v-model="item.auto.period">
                        <option v-for="(opt,idx) in option.period" :key="`opt-period-${idx}`"
                          :value="opt">{{ opt }}</option>
                      </select>
                      <div class="flex-1">분 마다</div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="sub3">회차간격</div>
                    <div class="grid-auto">
                      <select class="input-border" v-model="item.auto.space">
                        <option v-for="(opt,idx) in option.space" :key="`opt-space-${idx}`"
                                :value="opt">{{ opt }}</option>
                      </select>
                      <div class="flex-1">분 간격으로</div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="sub3">총 회차</div>
                    <div class="grid-auto">
                      <input type="number" v-model.number="item.auto.count">
                      <div class="flex-1">개 회차</div>
                    </div>
                  </div>
                </div>
                <admin-form-item label="운영시간 세부 설정" style="margin-top:20px" v-if="item.times.length>0">
                  <div class="time-table">
                    <div v-for="(tm,idx) in item.times" class="time-tr" :key="`time-tr-${idx}`">
                      <div class="time-th">{{ tm.start_time + '~' +tm.end_time }}</div>
                      <div class="time-td">
                        <div class="flex-center">
                          <toggle-button :value="tm.active"
                                         :sync="true"
                                         @change="e => tm.active = e.value"
                                         color="#34C759"
                                         :labels="{'checked':'영업', 'unchecked':'휴무'}"
                                         :width="60" :height="28"></toggle-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </admin-form-item>
              </admin-form-item>
            </template>
          </div>
        </div>

        <div class="grid-item" :class="{'border-bottom-0': item.repeat.type > 0}">
          <div class="grid-title">반복</div>
          <div>
            <div class="grid-repeat">
              <select v-model="item.repeat.type" class="input-border">
                <option v-for="(opt,idx) in repeatOption" :key="`opt-repeat-${idx}`"
                        :value="opt.value">{{ opt.label }}</option>
              </select>
              <div v-if="item.repeat.type > 0" class="size-13">마다 반복</div>
            </div>
            <div class="grid-week" v-if="item.repeat.type > 1 && item.repeat.type < 5">
              <div class="item-week unselect" v-for="(day, idx) in option.week" :key="`week-${idx}`"
                   :class="{'item-week-selected': item.repeat.weekdays.indexOf(day.value) > -1}"
                   @click="clickDayOfWeek(day.value)">{{ day.label }}</div>
            </div>
          </div>
        </div>
        <div class="grid-item" v-if="item.repeat.type > 0">
          <div class="grid-title">반복 기간</div>
          <div>
            <div class="flex" style="flex-wrap:wrap">
              <div style="align-items: center;">
                <admin-date-picker
                  type="date"
                  :not_before="moment(now).add(1, 'days').format('YYYY-MM-DD')"
                  :data="item.repeat.start_date"
                  @setDate="date => item.repeat.start_date = date"></admin-date-picker>
              </div>
              <div class="lp-dating">&#126;</div>
              <div style="align-items: center;">
                <admin-date-picker
                  type="date"
                  :not_before="notBefore"
                  :data="item.repeat.end_date"
                  @setDate="date => item.repeat.end_date = date"></admin-date-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-item">
          <div class="grid-title">모집인원</div>
          <!-- 일정별 모집인원 제한이거나, 옵션별로 모집인원 제한시 옵션 사용 안할 경우 전체 수량 -->
          <div v-if="reservePolicy.limit_type == 0 || item.selectorStocks.length === 0" class="flex-align" style="gap:0 16px">
            <div v-if="!item.stock_infinite" class="flex-align" style="gap:0 4px">
              <input type="number" v-model="item.stock" style="width:80px">
              <div class="size-13">명</div>
            </div>
            <lp-check-bool :checked-val.sync="item.stock_infinite"
                           :labelStyle="{fontSize: '13px', color:'#787878'}"
                           label="무한대"></lp-check-bool>
          </div>
          <div v-else>
            <div class="option-wrap">
              <div class="grid-opt">
                <div class="opt-header">옵션명</div>
                <div class="opt-header text-center">모집인원</div>
                <div class="opt-header text-center">예약인원</div>
              </div>
              <div class="grid-opt option-item-wrap" v-for="(opt,idx) in item.selectorStocks" :key="`stock-opt-${idx}`">
                <div class="flex-align option-item wrap" style="white-space: nowrap !important">
                  <div v-for="(child,cidx) in opt.options" :key="`opt-name-${cidx}`" class="flex-align">
                    <div class="opt-name-child">{{ child.name }}</div>
                    <div class="opt-name-divider" v-if="cidx < opt.options.length-1"></div>
                  </div>
                </div>
                <div class="option-item">
                  <div class="flex-align" style="gap:0 4px; margin-bottom: 8px">
                    <input type="number" v-model="opt.stock" style="width:80px" :disabled="!opt.enable_stock">
                    <div class="size-13">명</div>
                  </div>
                  <lp-check-bool :checked-val="!opt.enable_stock"
                                @onCheck="res => opt.enable_stock = !res"
                                :labelStyle="{fontSize: '13px', color:'#787878'}"
                                label="무한대"></lp-check-bool>
                </div>
                <div class="option-item flex-center size-14 ordered-count">{{ opt.ordered_count }}명</div>
              </div>
            </div>
            <div class="divider"></div>
            <div class="flex-align unselect"
                 @click="clickRefreshOption">
              <img :src="svgSrc('refresh')">
              <div class="size-13" style="color:#787878">옵션 기본 설정 인원으로 재설정</div>
            </div>
          </div>
        </div>

        <div class="grid-item">
          <div class="grid-title">가격</div>
          <div>
            <div style="width:262px">
              <div class="flex-align" style="margin-bottom:12px">
                <input class="input-border text-right" type="number"
                       placeholder="0" min="0" v-model.number="item.price">
                <div class="size-14" style="margin-left:4px">원</div>
              </div>
              <div class="flex-align" style="gap:0 12px">
                <select class="input-border" style="flex:1" v-model="item.discount_type">
                  <option :value="-1">할인없음</option>
                  <option :value="0">할인율</option>
                  <option :value="1">금액할인</option>
                </select>
                <div class="flex-align" style="flex:1">
                  <div v-if="item.discount_type===0" class="flex-align">
                    <input class="input-border text-right" type="number"
                           placeholder="0" min="0" v-model.number="item.discount_rate">
                    <div class="size-14" style="margin-left:4px">%</div>
                  </div>
                  <div v-else-if="item.discount_type===1" class="flex-align">
                    <input class="input-border text-right" type="number"
                           placeholder="0" min="0" v-model.number="item.discount_price">
                    <div class="size-14" style="margin-left:4px">원</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="size-14" style="margin-top:12px"
                 v-if="item.discount_type>-1">할인 후 가격<b style="margin-left:8px">{{ calcDiscount|currency }}</b></div>
            <template v-if="item.org">
              <div class="divider"></div>
              <div class="flex-align unselect"
                   @click="clickRefresh">
                <img :src="svgSrc('refresh')">
                <div class="size-13" style="color:#787878">기본 가격으로 재설정</div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="btn-group-justify-end" style="padding-top:12px">
        <button class="button is-light" @click="clickCancel">취소</button>
        <button class="button is-primary" @click="clickAccept">저장</button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from "sweet-modal-vue";
  import LpRadio from "../../../module/common/LpRadio";
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import LpTimePicker from "../../../module/common/LpTimePicker";
  import AdminTimePicker from "../../../module/admin/AdminTimePicker";
  import TimeRangePicker from "../../../module/common/timeRangePicker";
  import TimePicker from "../../../module/common/TimePicker";
  import moment from 'moment';

  export default {
    name: 'ModalReserveSchedule',
    components: {
      TimePicker,
      TimeRangePicker,
      AdminTimePicker,
      LpTimePicker,
      LpCheckBool,
      LpRadio,
      SweetModal
    },
    props: {
      prod: {
        type: Object
      },
      selectedDate: {
        type: Object
      },
      selectedTime: {
        type: String
      },
      selectorStocks: {
        type: Array
      },
      reservePrice: {
        type: Array
      },
      reservePolicy: {
        type: Object
      },
    },
    created() {
      this.now = moment().format('YYYY-MM-DD');
      this.notBefore = this.now;
    },
    methods: {
      clickDayOfWeek(day) {
        let index = this.item.repeat.weekdays.findIndex(i => i === day);
        if(index > -1) {
          removeIndex(this.item.repeat.weekdays, index);
        } else {
          this.item.repeat.weekdays.push(day);
          this.item.repeat.weekdays = this.item.repeat.weekdays.sort();
        }
      },
      init() {
        this.item = this.cloneItem(this.initItem);

        if(this.selectedDate) {
          this.item.start_date = this.selectedDate.date_str;
        } else {
          this.item.start_date = moment().format('YYYY-MM-DD');
        }
        this.item.repeat.start_date = this.item.start_date;

        if(this.selectedTime) {
          this.item.start_time = this.selectedTime;
        }
        this.item.stock = this.prod.stock;
        this.item.stock_infinite = this.prod.stock_type === 1;
        //if(this.reservePolicy.limit_type === 1) {
        // 옵션이 있는 경우에는, 일정별 재고수량 반영을 위해서 복제함.
        if(this.selectorStocks) {
          this.item.selectorStocks = this.cloneItem(this.selectorStocks);
        }
        this.clickRefresh();
      },
      open() {
        this.init();
        this.$refs.dateModal.open();
        this.$nextTick(() => {
          this.$refs.dateModal.$el.children[0].scrollTop = 0;
        })
      },
      clickRefresh() {
        let current = moment(this.item.start_date);
        let price = this.reservePrice.filter(i => moment(i.start_date).isSameOrBefore(current) && (
          (!i.end_date || i.end_date === '') || (i.end_date && i.end_date !== '' && moment(i.end_date).isSameOrAfter(current))
        ));
        if(price.length>0) {
          price = price[0];
          ['price','is_discount','discount_price','discount_rate','sale_price','discount_type'].forEach(k=>{ this.item[k] = price[k] });
        }
      },
      clickRefreshOption() {
        this.item.selectorStocks = this.cloneItem(this.selectorStocks);
      },
      clickCancel() {
        this.$refs.dateModal.close();
      },
      isValid() {
        let msg = '';
        if(this.item.type === 0) {
          if(!this.item.start_time || !this.item.end_time) {
            msg = '운영시간을 정확히 입력해주세요.';
          }
        }
        else {
          if(this.item.times.length === 0) {
            msg = '저장할 운영시간이 없습니다.';
          }
        }

        if(this.item.repeat.type > 0) {
          if(!this.item.repeat.start_date || !this.item.repeat.end_date) {
            msg = '반복기간을 입력해주세요.';
          }
        }

        if(msg!=='') {
          this.toast(msg);
        }
        return msg === '';
      },
      clickAccept() {
        if(!this.isValid()) return;
        this.item.is_discount = this.item.discount_type > -1;
        if(this.item.discount_type === 0) {
          this.item.sale_price = this.item.price - (this.item.price * (this.item.discount_rate / 100))
        } else if(this.item.discount_type === 1) {
          this.item.sale_price = this.item.price - this.item.discount_price;
        } else {
          this.item.sale_price = this.item.price;
        }

        this.item.limit_type = this.reservePolicy.limit_type

        this.$axios.post(this.getUrl(`reservation/product/${this.prod.id}/schedule`), this.item).then(res=> {
          if(res.status === 200) {
            this.$emit('accept');
            this.$refs.dateModal.close();
            this.toastStatus('일정이 저장되었습니다.');
          }
        }).catch(()=> {
          this.toastStatus('저장에 실패했습니다.');
        })
      },
      calcTimes() {
        this.item.times = [];
        let start_time = this.item.start_time;

        if(!start_time || start_time === '') return;

        let end_time = '';
        for(let i = 0; i < this.item.auto.count; i++) {
          if(end_time!=='') {
            start_time = moment(end_time, 'HH:mm').add(this.item.auto.space, 'minutes').format('HH:mm');
          }
          end_time = moment(start_time, 'HH:mm').add(this.item.auto.period, 'minutes').format('HH:mm');
          this.item.times.push({
            start_time: start_time,
            end_time: end_time,
            active: true
          })
        }
      },
      getWeeksDays(dates) {
        let selDate = moment(dates);
        let date = selDate.date();
        let day = selDate.day();
        let end_month = selDate.endOf('month').date();
        return {
          isLast: (date + 7 > end_month),
          week: Math.ceil(date/7),
          day: day,
          dayStr: ['일','월','화','수','목','금','토'][day]
        }
      },
    },
    computed: {
      repeatOption() {
        let days = this.getWeeksDays(this.item.start_date);
        let monthly = `매월 ${days.isLast ? '마지막주' : days.week + '번째 주'}`;
        return ['반복없음', '매일', '매주', '격주', monthly, '매년'].map((i,index) => {
          return {
            label: i,
            value: index,
            week: days.week,
            is_last: days.isLast
          }
        });
      },
      calcDiscount() {
        let price = 0;
        if(this.item.discount_type === 0) {
          price = this.item.price - (this.item.price * (this.item.discount_rate / 100))
        } else {
          price = this.item.price - this.item.discount_price;
        }
        return price;
      }
    },
    data() {
      return {
        now: '',
        notBefore: '',
        option: {
          types: [
            {
              label: '한 개 회차 생성',
              desc: '1회차 서비스 생성',
              value: 0
            },
            {
              label: '하루에 여러 회차 자동 생성',
              desc: '하루에 일정 간격으로 반복되는 다회차 서비스 자동 생성',
              value: 1
            }
          ],
          period: [30, 60, 90, 120, 180, 240, 300],
          space: [0, 10, 30, 60],
          week: [
            { label: '월', value: 0 },
            { label: '화', value: 1 },
            { label: '수', value: 2 },
            { label: '목', value: 3 },
            { label: '금', value: 4 },
            { label: '토', value: 5 },
            { label: '일', value: 6 }
          ]
        },
        item: undefined,
        initItem: {
          type: 0,
          start_date: undefined,
          start_time: undefined,
          end_time: undefined,
          auto: {
            period: 30,
            space: 60,
            count: 1
          },
          times: [],
          repeat: {
            type: 0,
            weekdays: [],
            start_date: undefined,
            end_date: undefined,
            week: 0,
            is_last: false
          },

          stock: 1,
          stock_infinite: false,
          selectorStocks: [],
          price: 0,
          is_discount: false,
          discount_type: 0,
          discount_rate: 0,
          discount_price: 0,
          sale_price: 0,
          org: {
            price: 0,
            is_discount: false,
            discount_type: 0,
            discount_rate: 0,
            discount_price: 0,
            sale_price: 0,
          }
        }
      }
    },
    watch: {
      'item.auto': {
        handler() {
          this.calcTimes();
        },
        deep: true
      },
      'item.repeat.start_date'(n) {
        this.notBefore = moment(n).add(1, 'days').format('YYYY-MM-DD');
      },
      'item.start_date'(n) {
        this.item.repeat.start_date = n;
      },
      'item.start_time'() {
        if(this.item.type === 1) {
          this.calcTimes();
        }
      },
      'item.repeat.type'(n) {
        if(n === 4) {
          let opt = this.repeatOption.filter(i => i.value === 4)[0];
          this.item.repeat.week = opt.week;
          this.item.repeat.is_last = opt.is_last;
        }
      },
      'item.stock_infinite'(n) {
        if (n) {
          this.item.stock = 0;
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  $primary = #ff5722

  .modal-reserve-schedule-container
    color #363636

  .modal-title
    font-size 20px
    font-weight 700
    margin-bottom 36px

  .input-border
    border 1px solid #cccccc
    border-radius 4px
    padding 7px
    width 100%
    flex 1
  input[type=number]
    color #363636
    text-align left
    padding-left 12px

  .grid-item
    display grid
    grid-template-columns 120px 1fr
    column-gap 8px
    padding-bottom 28px
    border-bottom 1px solid #eeeeee
    margin-bottom 28px
  .grid-item:last-child
    margin-bottom 0
    border-bottom 0

  .border-bottom-0
    border-bottom 0

  .divider
    width 100%
    height 1px
    background-color #eeeeee
    margin 12px 0

  .grid-title
    font-size 14px


  .opt-item
    flex 1
    border 1px solid #dddddd
    background-color #F5F5F5
    border-radius 4px
    padding 12px 15px
    color #363636
    .circle
      background-color white
      border 1px solid #cccccc
      border-radius 100%
      width 16px
      height 16px
    .desc
      color #787878
      font-size 13px
      margin-top 4px

  .opt-item-selected
    border 1px solid $primary
    background-color #fff0eb
    .circle
      border 3px solid $primary
    .opt-label
      color $primary
      letter-spacing -0.5px

  .auto-setting
    font-size 13px
    .grid-auto
      display grid
      grid-template-columns 80px 1fr
      grid-column-gap 4px
      align-items center
    .sub3
      color #aeaeae
      margin-bottom 4px
    input[type=number]
      color #363636
      text-align left
      padding-left 8px

  .time-table
    max-height 246px
    overflow-y auto
    border-top 1px solid #d9d9d9
  .time-tr
    display grid
    grid-template-columns repeat(2, 1fr)
    align-items center
    height 48px
    border-bottom 1px solid #d9d9d9
  .time-th
    background-color #f5f5f5
    font-size 13px
    color #363636
    text-align center
    height 100%
    line-height 47px

  .grid-repeat
    display grid
    grid-template-columns 210px 1fr
    grid-column-gap 8px
    align-items center

  .grid-week
    margin-top 12px
    display grid
    grid-template-columns repeat(7, 36px)
    grid-column-gap 4px
  .item-week
    border 1px solid #dddddd
    width 36px
    height 36px
    line-height 35px
    color #4a4a4a
    font-size 14px
    text-align center
  .item-week-selected
    color white
    background-color $primary
    border 1px solid $primary

  .text-right
    text-align right !important
  .option-wrap
    border 1px solid #eeeeee
  .grid-opt
    display grid
    grid-template-columns 1fr 140px 110px
    align-items center
  .opt-header
    color #787878
    background-color #f5f5f5
    border-bottom 1px solid #eeeeee
    padding 10px 12px
    font-size 14px
    font-weight 500
    border-right 1px solid #eeeeee
  .opt-header:last-child
    border-right 0

  .option-item-wrap
    height 80px
    border-bottom 1px solid #eeeeee
  .option-item-wrap:last-child
    border-bottom 0
  .option-item
    height 80px
    border-right 1px solid #eeeeee
    padding 10px 12px
  .option-item:last-child
    border-right 0
  .ordered-count
    color $primary
  .opt-name
    display flex
    flex-wrap wrap
  .opt-name-child
    font-size 14px
    color #323232
    padding-right 4px

  .opt-name-divider
    width 1px
    height 14px
    background-color #dddddd
    margin-right 4px

  .label-sub
    font-size 13px
    color #787878
    margin-bottom 8px
</style>

<style lang="stylus">
  .sweet-modal-overlay
    -webkit-perspective initial

  .modal-reserve-schedule-container
    .sweet-modal.is-alert
      width 620px
      max-height 90vh
    .sweet-modal.is-alert .sweet-content
      padding 28px 32px 16px 32px

    .mx-datepicker
      width 190px
    .time-picker-container
      min-width 140px
</style>
